/**
 * Tiny bridge so report OTP completion can disarm the back trap synchronously
 * without a circular import (session ↔ backTrap).
 */
type DismissListener = () => void;

let dismissListener: DismissListener | null = null;

export function registerGeniusDeeplinkDismissListener(
  listener: DismissListener | null,
): void {
  dismissListener = listener;
}

export function notifyGeniusDeeplinkFlowDismissed(): void {
  try {
    dismissListener?.();
  } catch {
    // ignore
  }
}
